/* ===========================================================
   HESAP İŞLEM FİŞ HTML BUILDER — SADECE GRAM

   Bu builder hem:
   - Browser / masaüstü print
   - Mobil Bluetooth raster print

   tarafından ortak olarak kullanılır.
=========================================================== */

export const buildFisHTML = (
  fis,
  oncekiBakiye,
  sonBakiye,
  tarih,
  hesapAdi,
  firmaAdi
) => {
  /* ===========================================================
     TÜRKÇE SAYI FORMAT

     15000     -> 15.000,00
     22000.05  -> 22.000,05
  =========================================================== */

  const fmtTR = (
    value,
    fractionDigits = null
  ) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "";
    }

    const number =
      Number(value);

    if (
      !Number.isFinite(number)
    ) {
      return "";
    }

    const digits =
      fractionDigits === null
        ? Number.isInteger(number)
          ? 0
          : 2
        : fractionDigits;

    return number.toLocaleString(
      "tr-TR",
      {
        minimumFractionDigits:
          digits,

        maximumFractionDigits:
          digits,
      }
    );
  };

  /* ===========================================================
     HTML ESCAPE
  =========================================================== */

  const escapeHtml = (
    value
  ) =>
    String(
      value ?? ""
    )
      .replace(
        /&/g,
        "&amp;"
      )
      .replace(
        /</g,
        "&lt;"
      )
      .replace(
        />/g,
        "&gt;"
      )
      .replace(
        /"/g,
        "&quot;"
      )
      .replace(
        /'/g,
        "&#039;"
      );

  /* ===========================================================
     FİŞ LİSTELERİ
  =========================================================== */

  const altinList =
    Array.isArray(
      fis?.altin
    )
      ? fis.altin
      : [];

  const ziynetList =
    Array.isArray(
      fis?.ziynet
    )
      ? fis.ziynet
      : [];

  const nakitList =
    Array.isArray(
      fis?.nakit
    )
      ? fis.nakit
      : [];

  const gramKarNakitList =
    Array.isArray(
      fis?.gramKarNakit
    )
      ? fis.gramKarNakit
      : [];

  const isNakitKarsiligiAltin =
    gramKarNakitList.length > 0;

  /* ===========================================================
     BAKİYELER
  =========================================================== */

  const onceki =
    oncekiBakiye || {
      gram: 0,
      tl: 0,
      usd: 0,
      eur: 0,
    };

  const son =
    sonBakiye || {
      gram: 0,
      tl: 0,
      usd: 0,
      eur: 0,
    };

  /* ===========================================================
     GRAM FİŞ TOPLAMI

     Fiş Top. =
     Sonraki - Önceki
  =========================================================== */

  const gramIslemToplam =
    (
      Number(
        son?.gram
      ) || 0
    ) -
    (
      Number(
        onceki?.gram
      ) || 0
    );

  /* ===========================================================
     SAFE METİNLER
  =========================================================== */

  const hesapAdiSafe =
    escapeHtml(
      hesapAdi || ""
    );

  const tarihSafe =
    escapeHtml(
      tarih || ""
    );

  const firmaAdiSafe =
    escapeHtml(
      firmaAdi || ""
    );

  /* ===========================================================
     HTML
  =========================================================== */

  return `
<!DOCTYPE html>

<html lang="tr">

<head>

  <meta charset="UTF-8" />

  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0"
  />

  <title>Fiş Önizleme</title>

  <style>

    /* ========================================================
       GENEL
    ======================================================== */

    * {
      box-sizing: border-box;
    }

    html,
    body {
      margin: 0;
      padding: 0;
    }

    @page {
      size: 75mm auto !important;
      margin: 0 !important;
    }

    body {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      width: 100%;

      margin: 0;
      padding: 0;

      background: #f3f3f3;

      color: #000000;

      font-family:
        Arial,
        Helvetica,
        sans-serif;

      -webkit-print-color-adjust:
        exact;

      print-color-adjust:
        exact;
    }

    /* ========================================================
       FİŞ ANA ALANI
    ======================================================== */

    .preview-wrapper {
      width: 75mm;
      min-width: 75mm;
      max-width: 75mm;

      margin-top: 10px;

      padding: 8px;

      background:
        #ffffff;

      color:
        #000000;

      border-radius:
        6px;

      box-shadow:
        0 0 8px
        rgba(
          0,
          0,
          0,
          0.15
        );

      overflow:
        hidden;
    }

    /* ========================================================
       BAŞLIK
    ======================================================== */

    .header-title {
      width: 100%;

      margin:
        0 0 4px 0;

      text-align:
        center;

      font-size:
        13px;

      font-weight:
        bold;

      line-height:
        1.2;
    }

    .header-date {
      width: 100%;

      text-align:
        center;

      font-size:
        11px;

      line-height:
        1.25;
    }

    .header-account {
      width: 100%;

      margin-top:
        5px;

      text-align:
        left;

      font-size:
        11px;

      line-height:
        1.25;
    }

    /* ========================================================
       BÖLÜM BAŞLIĞI
    ======================================================== */

    .section-title {
      width: 100%;

      margin-top:
        8px;

      margin-bottom:
        2px;

      padding-bottom:
        1px;

      text-align:
        center;

      font-size:
        10px;

      font-weight:
        bold;

      line-height:
        1.2;

      border-bottom:
        1px solid #999;
    }

    /* ========================================================
       GENEL TABLO
    ======================================================== */

    table {
      width: 100%;

      margin-top:
        6px;

      border-collapse:
        collapse;

      border-spacing:
        0;
    }

    th {
      margin: 0;

      padding:
        0 0 3px 0;

      border-bottom:
        1px solid #444;

      font-size:
        10px;

      font-weight:
        bold;

      line-height:
        1.15;

      vertical-align:
        bottom;
    }

    td {
      margin: 0;

      padding:
        2px 0;

      font-size:
        10px;

      line-height:
        1.15;

      vertical-align:
        top;
    }

    /* ========================================================
       ALTIN TABLOSU

       1 = A/V
       2 = Cinsi
       3 = Miktar
       4 = mm
       5 = Has
       6 = Adet
       7 = İşç.
       8 = Top.
    ======================================================== */

    table.altin-table {
      width: 100%;
      table-layout: fixed;
    }

    table.altin-table
    th:nth-child(1),
    table.altin-table
    td:nth-child(1) {
      width:
        8% !important;

      text-align:
        left !important;

      white-space:
        nowrap;
    }

    table.altin-table
    th:nth-child(2),
    table.altin-table
    td:nth-child(2) {
      width:
        14% !important;

      text-align:
        right !important;
    }

    table.altin-table
    th:nth-child(3),
    table.altin-table
    td:nth-child(3) {
      width:
        18% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    table.altin-table
    th:nth-child(4),
    table.altin-table
    td:nth-child(4) {
      width:
        10% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    table.altin-table
    th:nth-child(5),
    table.altin-table
    td:nth-child(5) {
      width:
        17% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    table.altin-table
    th:nth-child(6),
    table.altin-table
    td:nth-child(6) {
      width:
        9% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    table.altin-table
    th:nth-child(7),
    table.altin-table
    td:nth-child(7) {
      width:
        10% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    table.altin-table
    th:nth-child(8),
    table.altin-table
    td:nth-child(8) {
      width:
        14% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    /* ========================================================
       ZİYNET TABLOSU

       1 = A/V
       2 = Cinsi
       3 = Miktar
    ======================================================== */

    table.ziynet-table {
      width: 100%;

      table-layout:
        fixed;
    }

    table.ziynet-table
    th:nth-child(1),
    table.ziynet-table
    td:nth-child(1) {
      width:
        25% !important;

      text-align:
        left !important;

      white-space:
        nowrap;
    }

    table.ziynet-table
    th:nth-child(2),
    table.ziynet-table
    td:nth-child(2) {
      width:
        45% !important;

      text-align:
        right !important;
    }

    table.ziynet-table
    th:nth-child(3),
    table.ziynet-table
    td:nth-child(3) {
      width:
        30% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    /* ========================================================
       NAKİT TABLOSU

       1 = A/V
       2 = Birim
       3 = Miktar
    ======================================================== */

    table.nakit-table {
      width: 100%;

      table-layout:
        fixed;
    }

    table.nakit-table
    th:nth-child(1),
    table.nakit-table
    td:nth-child(1) {
      width:
        25% !important;

      text-align:
        left !important;

      white-space:
        nowrap;
    }

    table.nakit-table
    th:nth-child(2),
    table.nakit-table
    td:nth-child(2) {
      width:
        30% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    table.nakit-table
    th:nth-child(3),
    table.nakit-table
    td:nth-child(3) {
      width:
        45% !important;

      text-align:
        right !important;

      white-space:
        nowrap;
    }

    /* ========================================================
       ALTIN KARŞILIĞI NAKİT

       1 = A/V
       2 = Birim
       3 = Birim Kur
       4 = Altın Kur
       5 = Miktar
       6 = Gram
    ======================================================== */

    table.gramkarnakit-table {
      width: 100%;

      table-layout:
        fixed;
    }

    table.gramkarnakit-table
    th,
    table.gramkarnakit-table
    td {
      font-size:
        9px;

      white-space:
        nowrap;
    }

    table.gramkarnakit-table
    th:nth-child(1),
    table.gramkarnakit-table
    td:nth-child(1) {
      width:
        8% !important;

      text-align:
        left !important;
    }

    table.gramkarnakit-table
    th:nth-child(2),
    table.gramkarnakit-table
    td:nth-child(2) {
      width:
        14% !important;

      text-align:
        left !important;
    }

    table.gramkarnakit-table
    th:nth-child(3),
    table.gramkarnakit-table
    td:nth-child(3) {
      width:
        20% !important;

      text-align:
        right !important;
    }

    table.gramkarnakit-table
    th:nth-child(4),
    table.gramkarnakit-table
    td:nth-child(4) {
      width:
        20% !important;

      text-align:
        right !important;
    }

    table.gramkarnakit-table
    th:nth-child(5),
    table.gramkarnakit-table
    td:nth-child(5) {
      width:
        20% !important;

      text-align:
        right !important;
    }

    table.gramkarnakit-table
    th:nth-child(6),
    table.gramkarnakit-table
    td:nth-child(6) {
      width:
        18% !important;

      text-align:
        right !important;
    }

    /* ========================================================
       BAKİYE

       DOĞRU SIRA:

       Önceki | Sonraki | Fiş Top. | Birim
    ======================================================== */

    table.bakiye-table {
      width: 100%;

      table-layout:
        fixed;
    }

    table.bakiye-table
    th,
    table.bakiye-table
    td {
      white-space:
        nowrap;
    }

    table.bakiye-table
    th:nth-child(1),
    table.bakiye-table
    td:nth-child(1) {
      width:
        28% !important;

      text-align:
        right !important;
    }

    table.bakiye-table
    th:nth-child(2),
    table.bakiye-table
    td:nth-child(2) {
      width:
        28% !important;

      text-align:
        right !important;
    }

    table.bakiye-table
    th:nth-child(3),
    table.bakiye-table
    td:nth-child(3) {
      width:
        28% !important;

      text-align:
        right !important;
    }

    table.bakiye-table
    th:nth-child(4),
    table.bakiye-table
    td:nth-child(4) {
      width:
        16% !important;

      text-align:
        right !important;

      font-weight:
        bold;
    }

    /* ========================================================
       FOOTER
    ======================================================== */

    .footer {
      width:
        fit-content;

      margin:
        8px auto 0 auto;

      padding-top:
        4px;

      border-top:
        1px dashed #000;

      background:
        #ffffff !important;

      text-align:
        center;

      font-size:
        10px;

      white-space:
        nowrap;
    }

    /* ========================================================
       MASAÜSTÜ PRINT
    ======================================================== */

    @media print {

      html,
      body {
        width:
          75mm !important;

        margin:
          0 !important;

        padding:
          0 !important;

        background:
          #ffffff !important;
      }

      body {
        display:
          block !important;
      }

      .preview-wrapper {
        width:
          75mm !important;

        min-width:
          75mm !important;

        max-width:
          75mm !important;

        margin:
          0 !important;

        padding:
          8px !important;

        border-radius:
          0 !important;

        box-shadow:
          none !important;
      }
    }

    /* ========================================================
       MOBİL

       Mobilde farklı responsive fiş oluşturulmaz.

       AYNI 75 mm HTML:
       -> raster
       -> ESC/POS
       -> XP-80C
    ======================================================== */

    @media screen and (max-width: 768px) {

      html,
      body {
        margin:
          0;

        padding:
          0;
      }

      body {
        justify-content:
          center;
      }

      .preview-wrapper {
        width:
          75mm !important;

        min-width:
          75mm !important;

        max-width:
          75mm !important;

        margin-top:
          0 !important;
      }
    }

  </style>

</head>

<body>

  <!-- =========================================================
       RASTER KÖK ELEMENT

       HtmlToEscPosRaster.js bu alanı yakalar.
  ========================================================== -->

  <div
    id="fis-root"
    class="preview-wrapper"
  >

    <!-- =====================================================
         BAŞLIK
    ====================================================== -->

    <div class="header-title">
      ${firmaAdiSafe}
    </div>

    <div class="header-date">
      Tarih: ${tarihSafe}
    </div>

    <div class="header-account">
      Hesap: ${hesapAdiSafe}
    </div>

    <!-- =====================================================
         ALTIN İŞLEMLERİ
    ====================================================== -->

    ${
      altinList.length > 0
        ? `

      <div class="section-title">
        ALTIN İŞLEMLERİ
      </div>

      <table class="altin-table">

        <thead>

          <tr>

            <th>
              A/V
            </th>

            <th>
              Cinsi
            </th>

            <th>
              Miktar
            </th>

            <th>
              mm
            </th>

            <th>
              Has
            </th>

            <th>
              Adet
            </th>

            <th>
              İşç.
            </th>

            <th>
              Top.
            </th>

          </tr>

        </thead>

        <tbody>

          ${altinList
            .map(
              (row) => {
                const toplam =
                  (
                    Number(
                      row?.hasGram
                    ) || 0
                  ) +
                  (
                    Number(
                      row?.iscilikGram
                    ) || 0
                  );

                return `

            <tr>

              <td>
                ${
                  row?.islemTur
                    ?.endsWith(
                      "ALINDI"
                    )
                    ? "A"
                    : "V"
                }
              </td>

              <td>
                ${escapeHtml(
                  row?.stokAdi ||
                    ""
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.miktar,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.milyem,
                  0
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.hasGram,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.adet,
                  0
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.iscilik,
                  0
                )}
              </td>

              <td>
                ${fmtTR(
                  toplam,
                  2
                )}
              </td>

            </tr>

          `;
              }
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         ZİYNET
    ====================================================== -->

    ${
      ziynetList.length > 0
        ? `

      <div class="section-title">
        ZİYNET İŞLEMLERİ
      </div>

      <table class="ziynet-table">

        <thead>

          <tr>

            <th>
              A/V
            </th>

            <th>
              Cinsi
            </th>

            <th>
              Miktar
            </th>

          </tr>

        </thead>

        <tbody>

          ${ziynetList
            .map(
              (row) => `

            <tr>

              <td>
                ${
                  row?.islemTur
                    ?.endsWith(
                      "ALINDI"
                    )
                    ? "Alındı"
                    : "Verildi"
                }
              </td>

              <td>
                ${escapeHtml(
                  row?.stokAdi ||
                    ""
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.miktar,
                  0
                )}
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         NAKİT
    ====================================================== -->

    ${
      nakitList.length > 0
        ? `

      <div class="section-title">
        NAKİT İŞLEMLERİ
      </div>

      <table class="nakit-table">

        <thead>

          <tr>

            <th>
              A/V
            </th>

            <th>
              Birim
            </th>

            <th>
              Miktar
            </th>

          </tr>

        </thead>

        <tbody>

          ${nakitList
            .map(
              (row) => `

            <tr>

              <td>
                ${
                  row?.islemTur
                    ?.endsWith(
                      "ALINDI"
                    )
                    ? "Alındı"
                    : "Verildi"
                }
              </td>

              <td>
                ${escapeHtml(
                  row?.birim ||
                    ""
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.miktar,
                  2
                )}
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         ALTIN KARŞILIĞI NAKİT
    ====================================================== -->

    ${
      isNakitKarsiligiAltin
        ? `

      <div class="section-title">
        ALTIN KARŞILIĞI NAKİT
      </div>

      <table class="gramkarnakit-table">

        <thead>

          <tr>

            <th>
              A/V
            </th>

            <th>
              Birim
            </th>

            <th>
              Birim Kur
            </th>

            <th>
              Altın Kur
            </th>

            <th>
              Miktar
            </th>

            <th>
              Gram
            </th>

          </tr>

        </thead>

        <tbody>

          ${gramKarNakitList
            .map(
              (row) => `

            <tr>

              <td>
                ${
                  row?.islemTur
                    ?.endsWith(
                      "ALINDI"
                    )
                    ? "A"
                    : "V"
                }
              </td>

              <td>
                ${escapeHtml(
                  row?.birim ||
                    ""
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.birimKur,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.guncelKur,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.miktar,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  row?.gram ??
                    row?.toplam,
                  2
                )}
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         BAKİYE

         Önceki | Sonraki | Fiş Top. | Birim
    ====================================================== -->

    <div class="section-title">
      BAKİYE
    </div>

    <table class="bakiye-table">

      <thead>

        <tr>

          <th>
            Önceki
          </th>

          <th>
            Sonraki
          </th>

          <th>
            Fiş Top.
          </th>

          <th>
            Birim
          </th>

        </tr>

      </thead>

      <tbody>

        <tr>

          <td>
            ${fmtTR(
              onceki.gram,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              son.gram,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              gramIslemToplam,
              2
            )}
          </td>

          <td>
            Gram
          </td>

        </tr>

      </tbody>

    </table>

    <!-- =====================================================
         FOOTER
    ====================================================== -->

    <div class="footer">
      MALİ DEĞERİ YOKTUR
    </div>

  </div>

</body>

</html>
  `;
};